<nav class="nav">
  <ul class="header-nav">
    <li class="header-nav__item">
      <a href="https://bupl.dk" target="_blank" class="header-nav__link">BUPL.dk</a>
    </li>
    <li class="header-nav__item">
      <a href="https://pbu.dk" target="_blank" class="header-nav__link">PBU.dk</a>
    </li>
  </ul>
</nav>
